import React from 'react';

import { UserOutlined } from '@ant-design/icons';
import { Avatar, Select, SelectProps, Space } from 'antd';
import debounce from 'lodash/debounce';

import { useUsersQuery } from './hooks/useUsersQuery';

interface IProps extends SelectProps {
  placeholder: string;
  group_uid_ne?: string;
  labelInValue?: boolean;
}

export const UsersSelect: React.FC<IProps> = ({ placeholder, group_uid_ne, labelInValue = false, ...props }) => {
  const [uiSearch, setUiSearch] = React.useState(''); // что видно в инпуте
  const [nameContains, setNameContains] = React.useState(''); // что отправляем на бек

  const debouncedSetNameContains = React.useMemo(
    () =>
      debounce((v: string) => {
        setNameContains(v.trim());
      }, 400),
    []
  );

  React.useEffect(() => () => debouncedSetNameContains.cancel(), [debouncedSetNameContains]);

  const { data, hasNextPage, fetchNextPage, isFetching } = useUsersQuery({
    limit: 10,
    filters: {
      group_uid_ne,
      nameContains,
    },
  });

  const dataSource = data?.pages?.map((data) => data.items || []).flat() || [];

  return (
    <>
      <Select
        labelInValue={labelInValue}
        showSearch={{
          searchValue: uiSearch,
          autoClearSearchValue: false,
          filterOption: false,
          onSearch: (v) => {
            setUiSearch(v); // мгновенно, без debounce
            debouncedSetNameContains(v); // на бек — debounce
          },
        }}
        allowClear
        onPopupScroll={(e: any) => {
          const { target } = e;
          if (target?.scrollTop + 10 + target?.offsetHeight > target?.scrollHeight && hasNextPage && !isFetching) {
            fetchNextPage();
          }
        }}
        options={dataSource?.map((el) => ({
          label: `${el.first_name} ${el.last_name}`,
          value: el.pk,
          data: el,
        }))}
        notFoundContent={null}
        labelRender={(el: any) => {
          const opt = dataSource.find((u) => u.pk === el?.value);

          return (
            <Space style={{ display: 'flex', alignItems: 'center' }}>
              <Avatar size={25} src={opt?.avatar?.variants?.small?.url || ''} icon={<UserOutlined />} />
              {el?.label ?? `${opt?.first_name ?? ''} ${opt?.last_name ?? ''}`.trim()}
            </Space>
          );
        }}
        optionRender={(el: any) => {
          return (
            <Space style={{ display: 'flex', alignItems: 'center', verticalAlign: 'center' }}>
              <Avatar size={25} src={el?.data?.data?.avatar?.variants?.small?.url || ''} icon={<UserOutlined />} />
              {`${el?.data?.data?.first_name} ${el?.data?.data?.last_name}`}
            </Space>
          );
        }}
        {...props}
      />
    </>
  );
};
